import * as h2Api from '../h2Api'
import * as parentPortalActions from '../actions/parentPortal'

const initialState = {
  tabState: 'activityFeed',
  feed: [],
  filterVisible: false,
  upcomingEvents: [],
  selectedStudents: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case parentPortalActions.LOAD_INITIAL_ACTIVITY:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const values = {}

        action.restCall.result.users.forEach(u => (values[u.user.id] = true))

        return {
          ...state,
          feed: action.restCall.result.feed,
          users: action.restCall.result.users,
          upcomingEvents: action.restCall.result.upcomingEvents,
          selectedStudents: values
        }
      }

      return state

    case parentPortalActions.PARENT_TOGGLE_FILTER:
      return {
        ...state,
        filterVisible: !state.filterVisible
      }

    case parentPortalActions.PARENT_TOGGLE_CHILD:
      return {
        ...state,
        selectedStudents: {
          ...state.selectedStudents,
          [action.userId]: action.active
        }
      }

    case parentPortalActions.PARENT_CLICK_TAB:
      return {
        ...state,
        tabState: action.tabId
      }

    default:
      return state
  }
}
